export const api = {
    leadsOverview: '/leadview',
    leadsExcelExport: '/export/leads',
    leadItem: '/lead',
    publication: '/publication',
    workflowTask: '/workflow/:leadId/task',
    workflowCancel: '/workflow/:leadId/cancel',
    workflowCancelpendingActivities: '/workflow/:leadId/pendingActivities',
    auth: '/.auth/me',
    authUpdate: '/.auth/login/aad',
    workflowStates: '/workflow/states',
    identificationDetails: '/identification/details',
    mailJetEvents: '/mailjetEvents',
    identificationLogs: '/identification/logs/',
    kycDocument: '/document/kyc',
};
